var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.shouldShowShortcode)?_c('span',{class:{ 'cf-c-shortcode': !_vm.approved }},[_vm._v(" "+_vm._s(_vm.expression)+" ")]):_vm._e(),(_vm.inputComponent)?_c(_vm.inputComponent,{tag:"component",attrs:{"value":_vm.value,"input":_vm.input,"disabled":_vm.isDisabled,"approved":_vm.approved,"form":_vm.form}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }